<template>
  <StickyBarBottom
    v-if="!isOutOfStock && productResponse && selectedOffer && price"
    :price
    :price-without-subsidies
    :product="productResponse"
    :selected-mobile-plan
    :selected-offer
    :show-bar="!isContainerAddToCartMobileViewport"
    :tracking="productTracking"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import StickyBarBottom from '~/scopes/product-core/components/presentationals/StickyBarBottom/StickyBarBottom.vue'
import { useAddToCartVisibility } from '~/scopes/product-core/composables/useAddToCartVisibility/useAddToCartVisibility'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'
import { useFetchProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/useFetchProductTracking'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'

const { data: productResponse } = useFetchProduct()
const { isOutOfStock, selectedOffer } = useFetchPickers()
const { data: servicesPickersResponse } = useFetchServicePickers()
const { price, priceWithoutSubsidies } = useFetchProductPrice()
const { data: productTracking } = useFetchProductTracking()

const { checkVisibility } = useAddToCartVisibility()
const { isContainerAddToCartMobileViewport } = checkVisibility()

const selectedMobilePlan = computed(
  () =>
    servicesPickersResponse.value?.pickerGroups
      ?.find(({ id }) => id === 'mobile_plan')
      ?.items?.find(({ selected }) => !!selected)?.mobilePlanOffer ?? undefined,
)
</script>
